import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'

export const selectAppInitStatus = createSelector(
  [(state: ApplicationState) => state.AppInitStore.status],
  (status) => status
)

export const selectAppReady = createSelector(
  [selectAppInitStatus],
  (status) => status === 'ready'
)
